// extracted by mini-css-extract-plugin
export var alignBaseline = "_o-9";
export var alignCenter = "_o-5";
export var alignFlexEnd = "_o-7";
export var alignFlexStart = "_o-6";
export var alignSelfBaseline = "_o-e";
export var alignSelfCenter = "_o-a";
export var alignSelfFlexEnd = "_o-c";
export var alignSelfFlexStart = "_o-b";
export var alignSelfStretch = "_o-d";
export var alignStretch = "_o-8";
export var column = "_o-2";
export var columnReverse = "_o-4";
export var flex = "_o-0";
export var justifyCenter = "_o-f";
export var justifyFlexEnd = "_o-h";
export var justifyFlexStart = "_o-g";
export var justifySpaceAround = "_o-j";
export var justifySpaceBetween = "_o-i";
export var justifySpaceEvenly = "_o-k";
export var row = "_o-1";
export var rowReverse = "_o-3";
export var wrapNowrap = "_o-m";
export var wrapWrap = "_o-l";
export var wrapWrapReverse = "_o-n";